import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {ProductSearchFormModel} from "../models/forms/product-search-form.model";

export class ProductSearchForm extends ObservableBaseForm<ProductSearchFormModel>  {

    public get catalogueNumber(): AbstractControl {
        return this.formInstance.get("catalogueNumber") as AbstractControl;
    }

    public static createForm(formBuilder: FormBuilder, initialValues: ProductSearchFormModel): ProductSearchForm {
        const form = formBuilder.group({
            catalogueNumber: formBuilder.control(initialValues.catalogueNumber, Validators.required)
        });

        return new ProductSearchForm(form, initialValues);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: ProductSearchFormModel,
    ) {
        super(formInstance, initialValues);
    }

    public reset(): void {
        this.catalogueNumber.setValue(null, {emitEvent: false});
    }

    protected createChangeSubscription(): Observable<ProductSearchFormModel> {
        return this.catalogueNumber.valueChanges
            .pipe(
                switchMapTo(this.formInstance.statusChanges
                    .pipe(filter(this.validate))
                ),
                map(status => this.getModel())
            );
    }
}
